export default __webpack_public_path__ + "static/media/KhadakwaslaBanner.5e9e7963.png";